import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import { $InjectorLike, StateParams, StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { BackToDashboardService } from '../../../app.common/modules/common/services/back-to-dashboard.service';
import { AccountService } from '../account/account.service';
import { IRetailerStateData } from '../core/models';

function routesConfig($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider, $locationProvider: ng.ILocationProvider, $uiRouterProvider: any /* TODO */) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    $urlRouterProvider.otherwise(($injector: $InjectorLike) => {
        $injector.get('$state').go('errors.notfound');
    });

    // homepage
/*     $stateProvider
        .state('homepage', {
            url: '/'
        }); */

    // jispPay dashboards routes | "redirect routes" - these states will be redirected to url in "hard" way: this.$window.location.href = ...
    // see auth.service.ts checkIfRedirectState()
    $stateProvider.state('jisppay', {
            abstract: true
        }).state('jisppay.loyalty', {
            url: '/jisppay/loyalty'
        }).state('jisppay.sessionsList', {
            url: '/jisppay/jispgo'
        }).state('jisppay.orders', {
            url: '/jisppay/orders'
        }).state('jisppay.select-store', {
            url: '/seller/select-store'
        }).state('jisppay.default', {
            url: '/jisppay'
        }).state('jisppay.delivery', {
            url: '/jisppay/delivery/orders'
        });

    const defaultTemplate = '<div ui-view></div>';

    function redirect(state: string) {
        return ['$state', 'accountService', ($state: StateService, accountService: AccountService) => {
            if (accountService.userData.isAuth) {
                $state.go(state);
            } else {
                $state.go('account.login');
            }
        }];
    }

    $urlRouterProvider.when('/', redirect('home.screen'));
    $urlRouterProvider.when('/account', redirect('app.shops'));
    $urlRouterProvider.when('/dashboard', redirect('home.screen'));
    $urlRouterProvider.when('/dashboard/product', redirect('app.products'));
    $urlRouterProvider.when('/dashboard/marketing-campaigns', redirect('app.marketing-campaigns.overview'));
    $urlRouterProvider.when('/dashboard/account', redirect('app.account.statements'));
    $urlRouterProvider.when('/dashboard/jisppay', redirect('app.jisppay.places'));
    $urlRouterProvider.when('/dashboard/managers', redirect('app.managers.accounts'));
    $urlRouterProvider.when('/dashboard/discountForStaff', redirect('app.discountForStaffs.special.active'));
    $urlRouterProvider.when('/dashboard/bundle', redirect('app.bundles'));
    $urlRouterProvider.when('/dashboard/printers', redirect('app.printers.list'));
    $urlRouterProvider.when('/dashboard/vouchers', redirect('app.vouchers.list'));

    // retailer dashboard
    $stateProvider
        .state('home', {
            url: '/dashboard',
            abstract: true,
            template: require('../templates/page.html'),
            data: {
                auth: true
            }
        })
        .state('home.screen', {
            url: '/home',
            component: 'homeScreen',
            data: {
                auth: true,
                title: 'jisp Dashboard',
                translateKey: 'dashboard_title'
            }
        })
        .state('app', {
            url: '/dashboard',
            abstract: true,
            template: require('../templates/app.html'),
            data: {
                auth: true
            }
        }).state('app.profile', {
            url: '/profile',
            component: 'profile',
            data: {
                auth: true,
                title: 'Profile',
                translateKey: 'profile'
            } as IRetailerStateData
        }).state('app.shops', {
            url: '/places?active',
            component: 'shops',
            params: {
                active: { value: 'true', squash: true }
            },
            data: {
                auth: true,
                title: 'Places',
                translateKey: 'places'
            } as IRetailerStateData
        })
        .state('app.shop', {
            url: '/shop/:id',
            component: 'shop',
            data: {
                auth: true,
                title: 'Place',
                translateKey: 'place'
            } as IRetailerStateData
        })
        .state('app.shopTables', {
            url: '/shop/:id/tables',
            component: 'shopTablesList',
            params: {
                shopName: '',
                shopTown: '',
                openAddTable: false
            },
            data: {
                auth: true,
                title: 'Place',
                translateKey: 'place'
            } as IRetailerStateData
        })
        .state('app.create-shop', {
            url: '/shop/new',
            component: 'shop',
            data: {
                auth: true,
                title: 'Place',
                translateKey: 'place'
            } as IRetailerStateData
        })
        .state('app.product', {
            abstract: true,
            template: defaultTemplate,
            url: '/product',
            data: {
                auth: true
            }
        })
        .state('app.products', {
            url: '/products?page&column&order&state&search',
            component: 'products',
            params: {
                page: { value: '1', squash: false },
                column: { value: 'ID', squash: false },
                order: { value: 'descending', squash: false },
                state: { value: '1', squash: false },
                search: { value: '', squash: true }
            },
            data: {
                auth: true,
                title: 'Products',
                translateKey: 'products'
            } as IRetailerStateData
        })
        .state('app.product.edit', {
            url: '/{id}/edit',
            component: 'advancedProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        .state('app.product.copy', {
            url: '/{id}/copy',
            component: 'advancedProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        .state('app.product.new', {
            url: '/new',
            component: 'advancedProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        .state('app.product.new-wizard', {
            url: '/new-wizard',
            component: 'wizardProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        .state('app.product.copy-wizard', {
            url: '/{id}/copy-wizard',
            component: 'wizardProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        .state('app.product.edit-wizard', {
            url: '/{id}/edit-wizard',
            component: 'wizardProduct',
            data: {
                auth: true,
                title: 'Product',
                translateKey: 'product'
            } as IRetailerStateData
        })
        // Extras
        .state('app.extras', {
            abstract: true,
            template: defaultTemplate,
            url: '/extras',
            data: {
                auth: true,
            } as IRetailerStateData
        })
        .state('app.extras.active', {
            url: '/active',
            component: 'activeExtras',
            data: {
                auth: true,
                title: 'Extras',
                translateKey: 'extras'
            } as IRetailerStateData
        })
        .state('app.extras.archived', {
            url: '/archived',
            component: 'archivedExtras',
            data: {
                auth: true,
                title: 'Extras',
                translateKey: 'extras'
            } as IRetailerStateData
        })
        .state('app.extras.new', {
            url: '/new',
            component: 'addOrEditExtraItem',
            data: {
                auth: true,
                title: 'Extras',
                translateKey: 'extras'
            } as IRetailerStateData
        })
        .state('app.extras.edit', {
            url: '/{id}/edit',
            component: 'addOrEditExtraItem',
            data: {
                auth: true,
                title: 'Extras',
                translateKey: 'extras'
            } as IRetailerStateData
        })
        // NFC
        .state('app.nfc', {
            abstract: true,
            template: defaultTemplate,
            url: '/nfc',
            data: {
                auth: true
            }
        })
        .state('app.nfcs', {
            url: '/nfc',
            component: 'nfcRetailerTabList',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })
        .state('app.nfcs.active', {
            url: '/active',
            component: 'nfcRetailerActiveTab',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })
        .state('app.nfcs.deleted', {
            url: '/deleted',
            component: 'nfcRetailerDeletedTab',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })
        .state('app.nfcs.history', {
            url: '/history',
            component: 'nfcRetailerHistoryTab',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })
        .state('app.nfcs.export', {
            url: '/export',
            component: 'NfcExport',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })
        .state('app.nfc.wizard', {
            url: '/wizard',
            component: 'nfcWizard',
            data: {
                auth: true,
                title: 'NFC Assignment',
                translateKey: 'nfc_assignment'
            } as IRetailerStateData
        })

        .state('app.staff-rating', {
            abstract: true,
            template: defaultTemplate,
            url: '/staffRating',
            data: {
                auth: true
            }
        })
        .state('app.staff-ratings', {
            url: '/staffRatings?column&order',
            component: 'staffRatingList',
            params: {
                column: { value: 'Name', squash: false },
                order: { value: 'descending', squash: false },
            },
            data: {
                auth: true,
                title: 'Staff rating',
                translateKey: 'staff_rating'
            } as IRetailerStateData
        })
        .state('app.staff-rating.details', {
            url: '/{id}',
            component: 'staffRatingDetails',
            params: {
                id: { value: '1', squash: false }
            },
            data: {
                auth: true,
                title: 'Staff rating',
                translateKey: 'staff_rating'
            } as IRetailerStateData
        })

        .state('app.information-card', {
            abstract: true,
            template: defaultTemplate,
            url: '/infotag',
            data: {
                auth: true
            }
        })
        .state('app.information-cards', {
            url: '/infotags?page&column&order&state&search',
            component: 'informationCards',
            params: {
                page: { value: '1', squash: false },
                column: { value: 'ID', squash: false },
                order: { value: 'descending', squash: false },
                state: { value: '1', squash: false },
                search: { value: '', squash: true }
            },
            data: {
                auth: true,
                title: 'InfoTags',
                translateKey: 'information_cards'
            } as IRetailerStateData
        })
        .state('app.information-card.edit', {
            url: '/{id}/edit',
            component: 'informationCard',
            data: {
                auth: true,
                title: 'InfoTag',
                translateKey: 'information_card'
            } as IRetailerStateData
        })
        .state('app.information-card.new', {
            url: '/new',
            component: 'informationCard',
            data: {
                auth: true,
                title: 'InfoTag',
                translateKey: 'information_card'
            } as IRetailerStateData
        })

        // .state('app.tags', {
        //     url: '/tags',
        //     component: 'jispTags',
        //     data: <IRetailerStateData>{
        //         auth: true,
        //         title: 'Jisptags',
        //         translateKey: 'jisptags'
        //     }
        // })
        // .state('app.operations.help', {
        //     abstract: true,
        //     template: defaultTemplate,
        //     url: '/help'
        // })
        .state('app.help', {
            url: '/help',
            abstract: true,
            template: defaultTemplate
        })
        .state('app.help.manual', {
            url: '/manual',
            component: 'helpPage',
            data: {
                auth: false,
                title: 'Help',
                translateKey: 'help'
            } as IRetailerStateData
        })
        .state('app.help.dictionary', {
            url: '/dictionary',
            component: 'helpDictionary',
            data: {
                auth: false,
                title: 'List of categories and item types',
                translateKey: 'list_of_categories'
            } as IRetailerStateData
        })
        .state('app.help.preferences', {
            url: '/preferences',
            component: 'helpPreferences',
            data: {
                auth: false,
                title: 'List of food preferences and allergens',
                translateKey: 'list_of_preferences'
            } as IRetailerStateData
        })
        .state('app.help.countries', {
            url: '/countries',
            component: 'helpCountries',
            data: {
                auth: false,
                title: 'List of origin countries',
                translateKey: 'list_of_countries'
            } as IRetailerStateData
        })
        .state('app.menus', {
            url: '/menus?archived',
            component: 'menus',
            data: {
                auth: true,
                title: 'Menus',
                translateKey: 'menus'
            } as IRetailerStateData
        })
        .state('app.create-menu', {
            url: '/menu/new',
            component: 'menu.editor',
            data: {
                auth: true,
                title: 'Menu',
                translateKey: 'menus'
            } as IRetailerStateData
        })
        .state('app.edit-menu', {
            url: '/menu/{id}?duplicate',
            component: 'menu.editor',
            data: {
                auth: true,
                title: 'Menu',
                translateKey: 'menus'
            } as IRetailerStateData
        })

        .state('app.activeIngredients', {
            url: '/ingredients/active',
            component: 'ingredientsTabs',
            params: {
                isActive: { value: true }
            },
            data: {
                auth: true,
                title: 'Ingredients',
                translateKey: 'ingredients'
            } as IRetailerStateData
        })

        .state('app.archivedIngredients', {
            url: '/ingredients/archived',
            component: 'ingredientsTabs',
            params: {
                isActive: { value: false }
            },
            data: {
                auth: true,
                title: 'Ingredients',
                translateKey: 'ingredients'
            } as IRetailerStateData
        })

        .state('app.inventory', {
            url: '/shop/{shopId:int}/inventory',
            component: 'inventory',
            params: {
                shop: null
            },
            data: {
                auth: true,
                title: 'Inventory',
                translateKey: 'inventory'
            } as IRetailerStateData
        })
        .state('app.operations', {
            url: '/operations?page&from&to&filter',
            component: 'importTab',
            data: {
                auth: true,
                title: 'Operations'
            } as IRetailerStateData,
            params: {
                page: { value: '1', squash: true, dynamic: true },
                from: { squash: true, dynamic: true },
                to: { squash: true, dynamic: true },
                filter: { squash: true, dynamic: true }
            }
        })
        .state('app.operation', {
            url: '/operation?:id',
            component: 'operationComponent',
            data: {
                auth: true,
                title: 'Operation'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns', {
            abstract: true,
            template: defaultTemplate,
            url: '/marketing-campaigns',
            data: {
                auth: true
            }
        })
        .state('app.marketing-campaigns.new-templated', {
            url: '/new-templated/:name',
            component: 'marketingCampaign',
            data: {
                auth: true,
                title: 'Create a Marketing campaign',
                translateKey: 'create_a_marketing_campaign'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns.new-branded', {
            url: '/new-branded',
            component: 'marketingCampaign',
            data: {
                auth: true,
                title: 'Create a Marketing campaign',
                translateKey: 'create_a_marketing_campaign'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns.overview', {
            url: '/overview',
            component: 'campaignsOverview',
            data: {
                auth: true,
                title: 'Campaigns Overview',
                translateKey: 'campaigns_overview'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns.view', {
            url: '/{id:int}',
            component: 'viewCampaign',
            data: {
                auth: true,
                title: 'Campaign view',
                translateKey: 'campaign_view'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns.edit', {
            url: '/{id:int}/edit',
            component: 'marketingCampaign',
            data: {
                auth: true,
                title: 'Edit a Marketing campaign',
                translateKey: 'edit_a_marketing_campaign'
            } as IRetailerStateData
        })
        .state('app.marketing-campaigns.copy', {
            url: '/{id:int}/copy',
            component: 'marketingCampaign',
            data: {
                auth: true,
                title: 'Copy a Marketing campaign',
                translateKey: 'copy_a_marketing_campaign'
            } as IRetailerStateData
        })
        .state('app.marketplace', {
            url: '/marketplace',
            component: 'adForMarketplace',
            data: {
                auth: true,
                title: 'Ad for Marketplace',
                translateKey: 'ad_for_marketplace'
            } as IRetailerStateData
        })
        .state('app.referral-accounts', {
            url: '/referral-accounts',
            component: 'referralAccounts',
            data: {
                auth: true,
                title: 'Referral Accounts',
                translateKey: 'menu_referral_accounts'
            } as IRetailerStateData,
            params: {
                page: { value: 1, squash: false },
                column: { value: 'ID', squash: false },
                order: { value: 'descending', squash: false },
                active: { value: 'true', squash: false },
                search: { value: '', squash: true }
            }
        })
        .state('app.jisppay', {
            url: '/jisppay',
            abstract: true,
            template: defaultTemplate,
            data: {
                auth: true
            }
        })
        .state('app.jisppay.places', {
            url: '/places',
            component: 'jispPayPlaces',
            data: {
                auth: true,
                title: 'jispPAY Places',
                translateKey: 'menu_jisp_pay_places'
            } as IRetailerStateData
        })
        .state('app.jisppay.staff', {
            url: '/staff',
            component: 'jispPayStaff',
            data: {
                auth: true,
                title: 'Staff Accounts',
                translateKey: 'staff_accounts'
            } as IRetailerStateData
        })
        .state('app.managers', {
            url: '/managers',
            abstract: true,
            template: defaultTemplate,
            data: {
                auth: true
            }
        })
        .state('app.managers.accounts', {
            url: '/accounts',
            component: 'storeManagerAccounts',
            data: {
                auth: true,
                title: 'Store manager accounts',
                translateKey: 'store_manager_accounts',
                onlyRetailer: true,
            } as IRetailerStateData
        })
        .state('app.orderSettings', {
            url: '/orderSettings',
            abstract: true,
            template: defaultTemplate,
            data: {
                auth: true
            }
        })
        .state('app.orderSettings.locations', {
            url: '/locations',
            component: 'orderSettingsLocations',
            data: {
                auth: true,
                title: 'Order settings',
                translateKey: 'menu_order_settings'
            } as IRetailerStateData
        })
        .state('app.discountForStaff', {
            abstract: true,
            template: defaultTemplate,
            url: '/discountForStaff',
            data: {
                auth: true
            }
        })
        .state('app.discountForStaffs', {
            url: '/discountForStaff',
            component: 'discountForStaffTabList',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.special', {
            url: '/special',
            component: 'discountForStaffSpecialTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.special.active', {
            url: '/active',
            component: 'discountForStaffSpecialActiveTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.special.archived', {
            url: '/archived',
            component: 'discountForStaffSpecialActiveTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.transaction', {
            url: '/transaction',
            component: 'discountForStaffHistoryTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.transaction.with-discount', {
            url: '/withDiscount',
            component: 'transactionWithDiscountTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.transaction.export', {
            url: '/export',
            component: 'transactionExportHistoryTab',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.discountForStaffs.transaction.singleTransaction', {
            url: '/single-transaction/{id:int}',
            component: 'discountForStaffSingleTransaction',
            data: {
                auth: true,
                title: 'Special discount for employees',
                translateKey: 'discount-for-staff-active-title'
            } as IRetailerStateData
        })
        .state('app.analytics', {
            url: '/analytics',
            component: 'analytics',
            params: {
                no_anim: { value: 'true' }
            },
            data: {
                auth: true,
                title: 'Analytics',
                translateKey: 'menu_analytics'
            }
        })
        .state('app.warnings', {
            url: '/warnings',
            component: 'warnings',
            params: {
                no_anim: { value: 'true' }
            },
            data: {
                auth: true,
                title: 'Warnings',
                translateKey: 'menu_warnings'
            }
        })
        .state('app.clickAndDeliver', {
            url: '/clickAndDeliver',
            component: 'clickAndDeliver',
            params: {
                no_anim: { value: 'true' }
            },
            data: {
                auth: true,
                title: 'Click & Deliver',
                translateKey: 'menu_click_and_deliver'
            }
        })
        .state('app.vouchers', {
            abstract: true,
            url: '/vouchers',
            template: defaultTemplate,
            data: {
                auth: true
            }
        })
        .state('app.vouchers.list', {
            component: 'vouchersListComponent',
            url: '',
            data: {
                title: 'Vouchers',
                translateKey: 'vouchers',
                auth: true
            }
        })
        .state('app.vouchers.edit', {
            component: 'addOrEditVoucher',
            url: '/{id:int}/edit',
            data: {
                title: 'Edit vouchers',
                translateKey: 'vouchers_edit',
                auth: true
            }
        })
        .state('app.vouchers.new', {
            component: 'addOrEditVoucher',
            url: '/new',
            data: {
                title: 'New vouchers',
                translateKey: 'vouchers_new',
                auth: true
            }
        })
        .state('app.bundle', {
            abstract: true,
            template: defaultTemplate,
            url: '/bundle',
            data: {
                auth: true
            }
        })
        .state('app.bundles', {
            component: 'bundleListComponent',
            url: '/bundles',
            data: {
                title: 'Bundles',
                translateKey: 'bundles',
                auth: true
            } as IRetailerStateData
        })
        .state('app.bundle.details', {
            component: 'bundleDetailsComponent',
            url: '/{id:int}',
            data: {
                title: 'Bundle Details',
                translateKey: 'bundle_details',
                auth: true
            } as IRetailerStateData
        })
        .state('app.bundle.new', {
            component: 'newEditBundleComponent',
            url: '/new',
            data: {
                title: 'New Bundle',
                translateKey: 'bundle_new',
                auth: true
            } as IRetailerStateData
        })
        .state('app.bundle.edit', {
            component: 'newEditBundleComponent',
            url: '/{id:int}/edit',
            data: {
                title: 'Edit Bundle',
                translateKey: 'bundle_edit',
                auth: true
            } as IRetailerStateData
        })
        .state('app.printers', {
            abstract: true,
            template: defaultTemplate,
            url: '/printers',
            data: {
                auth: true
            }
        })
        .state('app.printers.list', {
            component: 'printerListComponent',
            url: '/printers',
            data: {
                title: 'Printers',
                translateKey: 'printers',
                auth: true
            } as IRetailerStateData
        })
        .state('app.printers.new', {
            component: 'addEditPrinterComponent',
            url: '/new',
            data: {
                title: 'New Printer',
                translateKey: 'printer_new',
                auth: true
            } as IRetailerStateData
        })
        .state('app.printers.edit', {
            component: 'addEditPrinterComponent',
            url: '/{printerID:int}/{placeID:int}',
            data: {
                title: 'Edit Printer',
                translateKey: 'printer_edit',
                auth: true
            } as IRetailerStateData
        });
    /* nfrn */
    $stateProvider
        .state('nfrn', {
            url: '/nfrn',
            abstract: true,
            template: defaultTemplate
        })
        .state('nfrn.applyToken', {
            url: '/applyToken?auth',
            params: {
                auth: {value: '', squash: false}
            },
            controller: ['$state', '$stateParams', '$localStorage', 'accountService', 'backToDashboardService', (
                $state: StateService,
                $stateParams: StateParams,
                $localStorage: ngStorage.StorageService,
                accountService: AccountService,
                backToDashboardService: BackToDashboardService
            ) => {
                delete $localStorage.retailerAuthorizationData;
                accountService.updateRetailerToken($stateParams.auth);
                if (document.referrer) {
                    backToDashboardService.trySetLink(document.referrer);
                }
                $state.go('app.jisppay.staff');
            }],
            data: {
                auth: false
            }
        }).state('nfrn.seller', {
            url: '/seller?code&tabId',
            params: {
                code: {value: '', squash: false},
                tabId: {value: '', squash: false}
            },
            controller: ['$state', '$stateParams', 'jispPayAccountService', 'notificationService', 'siteRetailerHomeUrl', 'backToDashboardService',
                ($state, $stateParams, jispPayAccountService, notificationService, siteRetailerHomeUrl, backToDashboardService: BackToDashboardService) => {
                notificationService.showWaitingMessage();
                jispPayAccountService.logInByLoginCode($stateParams.code)
                    .then((response) => {
                        if (document.referrer) {
                            backToDashboardService.trySetLink(document.referrer);
                        }
                        if ($stateParams.tabId) {
                            jispPayAccountService.navigateTo(+$stateParams.tabId);
                        } else {
                            jispPayAccountService.navigateToDefault();
                        }
                    })
                    .catch((err) => {
                        notificationService.showErrorMessage(err);
                        setTimeout(() => {
                            window.location.href = siteRetailerHomeUrl;
                        }, 5000);
                    });
            }],
            data: {
                auth: false
            }
        });
    // help
    $stateProvider
        .state('help', {
            url: '/help',
            abstract: true,
        })
        .state('help.dictionary', {
            url: '/dictionary',
            component: 'helpDictionary',
            data: {
                auth: false,
                title: 'List of categories and item types',
                translateKey: 'list_of_categories'
            } as IRetailerStateData
        })
        .state('help.preferences', {
            url: '/preferences',
            component: 'helpPreferences',
            data: {
                auth: false,
                title: 'List of food preferences and allergens',
                translateKey: 'list_of_preferences'
            } as IRetailerStateData
        })
        .state('help.countries', {
            url: '/countries',
            component: 'helpCountries',
            data: {
                auth: false,
                title: 'List of origin countries',
                translateKey: 'list_of_countries'
            } as IRetailerStateData
        })
        ;
    // account management for unauth users
    $stateProvider
        .state('account', {
            url: '/account',
            abstract: true,
            template: require('../templates/page.html'),
            data: {
                auth: false
            }
        })
        .state('account.login', {
            url: '/login',
            component: 'login',
            data: {
                auth: false,
                title: 'Log in',
                translateKey: 'log_in'
            } as IRetailerStateData
        })
        .state('account.selectRole', {
            url: '/forgot',
            component: 'selectRole',
            data: {
                auth: false,
                title: 'Select your position',
                translateKey: 'forgot_password_str'
            } as IRetailerStateData
        })
        .state('account.forgot', {
            url: '/forgot',
            component: 'forgotPassword',
            data: {
                auth: false,
                title: 'Forgot password',
                translateKey: 'forgot_password_str'
            } as IRetailerStateData
        })
        .state('account.resetSuccess', {
            url: '/forgot',
            component: 'resetSuccess',
            data: {
                auth: false,
                title: 'Forgot password',
                translateKey: 'forgot_password_str'
            } as IRetailerStateData
        })
        .state('account.reportSupervisor', {
            url: '/forgot',
            component: 'reportSupervisor',
            data: {
                auth: false,
                title: 'Report to your supervisor',
                translateKey: 'forgot_password_str'
            } as IRetailerStateData
        })
        .state('account.reset', {
            url: '/reset/:id/:key',
            component: 'resetPassword',
            data: {
                auth: false,
                title: 'Reset password',
                translateKey: 'reset_password_str'
            } as IRetailerStateData
        })
        .state('app.activeServices', {
            url: '/services/active',
            component: 'servicesTabs',
            params: {
                isActive: { value: true }
            },
            data: {
                auth: true,
                title: 'Services',
                translateKey: 'services_tab'
            } as IRetailerStateData
        })

        .state('app.archivedServices', {
            url: '/services/archived',
            component: 'servicesTabs',
            params: {
                isActve: { value: false }
            },
            data: {
                auth: true,
                title: 'Services',
                translateKey: 'services_tab'
            } as IRetailerStateData
        })
        .state('app.serviceCreate', {
            url: '/services/new',
            component: 'addOrEditService',
            data: {
                auth: true,
                title: 'Service',
                translateKey: 'services_tab'
            } as IRetailerStateData
        })
        .state('app.editService', {
            url: '/services/{id}/edit',
            component: 'addOrEditService',
            data: {
                auth: true,
                title: 'Service',
                translateKey: 'services_tab'
            } as IRetailerStateData
        })
        .state('app.downloads', {
            url: '/analytics/downloads',
            component: 'downloads',
            data: {
                auth: true,
                title: 'Downloads',
                translateKey: 'downloads'
            } as IRetailerStateData
        })
        .state('app.publisherSettings', {
            url: '/publisher-settings',
            component: 'publisherSettings',
            data: {
                auth: true,
                title: 'Publisher Settings',
                translateKey: 'publisher_settings'
            } as IRetailerStateData
        });

    // errors
    $stateProvider
        .state('errors', {
            url: '/errors',
            abstract: true,
            template: require('../templates/page.html')
        })
        .state('errors.notfound', {
            url: '/notfound',
            template: require('../../../app.common/modules/templates/notFound.html')
        })
        .state('errors.forbidden', {
            url: '/forbidden',
            template: require('../../../app.common/modules/templates/forbidden.html')
        });
}

angular.module('naut').config(routesConfig);

routesConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$uiRouterProvider'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/routes/routes.config.ts